module.exports = __webpack_public_path__ + "static/media/TheBreakupLists.e09f4799.jpg";